import { openModal, closeModal } from './bouchilino-product-dialog-r19.js';

class BouchilinoProductHelp extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const trigger = this.querySelector('[data-size-guide]');
    if (!trigger) return;
    trigger.hidden = false;
    trigger.addEventListener('click', () => this.openGuide(trigger), { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    if (this.dialog?.open) closeModal({ restore: false });
  }

  productForm() {
    return this.closest('.product-details')?.querySelector('product-form-component form');
  }

  async openGuide(trigger) {
    const template = this.querySelector('template[data-size-dialog]');
    if (!template) return;
    const dialog = template.content.firstElementChild.cloneNode(true);
    this.dialog = dialog;
    const form = this.productForm();
    for (const button of dialog.querySelectorAll('[data-guide-add]')) {
      const selected = form?.querySelector('[name="id"]')?.value;
      button.textContent = selected === button.dataset.guideAdd ? button.dataset.addLabel : button.dataset.chooseLabel;
      button.addEventListener('click', async () => {
        if (button.disabled) return;
        button.disabled = true;
        await closeModal({ restore: false });
        const currentForm = this.productForm();
        const submit = currentForm?.querySelector('button[type="submit"]');
        const matches = currentForm?.querySelector('[name="id"]')?.value === button.dataset.guideAdd;
        // Keep validation, request locking, error translation and cart sections in Horizon.
        if (matches && currentForm?.isConnected && submit?.isConnected && submit.form === currentForm && !submit.disabled && currentForm.getAttribute('aria-busy') !== 'true') {
          submit.focus({ preventScroll: true });
          currentForm.requestSubmit(submit);
        } else {
          const picker = this.closest('.product-details')?.querySelector('variant-picker input:not([disabled]),variant-picker select:not([disabled])');
          const target = picker || submit || trigger;
          target?.focus({ preventScroll: false });
          target?.scrollIntoView({ block: 'center', behavior: 'instant' });
        }
      });
    }
    dialog.addEventListener('b19:closed', () => { if (this.dialog === dialog) this.dialog = null; }, { once: true });
    await openModal(dialog, trigger);
  }
}

if (!customElements.get('bouchilino-product-help-r19')) customElements.define('bouchilino-product-help-r19', BouchilinoProductHelp);
